<template>
  <div class="sm:col-span-1" v-if="props.adminView">
    <dt class="text-sm font-medium text-gray-500">{{ model?.label }}</dt>

    <dd class="mt-1 text-sm text-gray-900">
      <fieldset>
        <legend class="sr-only">{{ model?.label }}</legend>
        <div class="space-y-1">
          <InputPeriodCheckbox
            v-for="(item, index) in withoutGroup"
            :key="index"
            :label="item?.input.label"
            :model="item.input"
            :id="item?.input.key"
            @change="onChange"
            :disabled="!editMode"
            :admin-view="true"
          ></InputPeriodCheckbox>
        </div>
      </fieldset>
    </dd>
  </div>
  <div class="w-full" v-else>
    <p class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold">
      {{ model.label }}
    </p>
    <InputPeriodCheckbox
      v-for="(item, index) in withoutGroup"
      :key="index"
      :label="item?.input.label"
      :model="item.input"
      :id="item?.input.key"
      @change="onChange"
      :disabled="disabled"
    ></InputPeriodCheckbox>
  </div>
</template>
<script setup lang="ts">
import { defineProps, computed, ref, onMounted } from "vue";
import { defineEmits, reactive } from "@vue/runtime-core";
import * as dtos from "@/models/dtos";
import InputPeriodCheckbox from "./InputPeriodCheckbox.vue";
import { RangeRoot } from "@/models/forms/AgePeriod";
const emit = defineEmits(["change"]);

const periodsWithRange = reactive(new Array<RangeRoot>());
const withoutGroup = computed(() =>
  periodsWithRange.filter((px) => px.input.type !== "periodGroup")
);

const props = defineProps({
  model: {
    required: true,
    type: dtos.DynamicProperty,
  },
  placeholder: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
});

onMounted(() => {
  var properties = (
    model.value.data.metadata as dtos.MetaData
  ).properties.filter((x) => props.model.data.keys.includes(x.key));
  properties.forEach((x) => {
    periodsWithRange.push(new RangeRoot(x));
  });
});

let model = ref(props.model);

function onChange(e: any) {
  emit("change", e);
}
</script>
